import { FieldPath, UseFormSetError } from "react-hook-form";

import { ConfigFormValues, IntegrationFormValues } from "@modules/erpIntegrations/validations";

const INTEGRATION_FORM_FIELDS = new Set<string>([
  "name",
  "description",
  "documentation_url",
  "instructions",
]);

export function applyIntegrationApiErrors(
  error: unknown,
  setError: UseFormSetError<IntegrationFormValues>
) {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (!data || typeof data !== "object") return;

  for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
    if (!INTEGRATION_FORM_FIELDS.has(key)) continue;

    const message = Array.isArray(value)
      ? value.map(String).join(" ")
      : typeof value === "string"
        ? value
        : "";

    if (!message) continue;

    setError(key as FieldPath<IntegrationFormValues>, { type: "server", message });
  }
}

const CONFIG_FORM_FIELDS = new Set<string>(["test_document"]);

export function applyConfigApiErrors(
  error: unknown,
  setError: UseFormSetError<ConfigFormValues>
) {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (!data || typeof data !== "object") return;

  for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
    if (!CONFIG_FORM_FIELDS.has(key)) continue;

    const message = Array.isArray(value)
      ? value.map(String).join(" ")
      : typeof value === "string"
        ? value
        : "";

    if (!message) continue;

    setError(key as FieldPath<ConfigFormValues>, { type: "server", message });
  }
}

export function getErpErrorMessage(error: unknown): string {
  const data = (error as { response?: { data?: unknown } })?.response?.data;

  if (data && typeof data === "object" && data !== null && "error" in data) {
    const message = (data as { error?: unknown }).error;
    if (message) return String(message);
  }

  if (data && typeof data === "object") {
    const messages = Object.values(data as Record<string, unknown>).flatMap((value) => {
      if (Array.isArray(value)) return value.map(String);
      if (typeof value === "string") return [value];
      return [];
    });
    if (messages.length > 0) return messages.join(" ");
  }

  if (data !== undefined) {
    return typeof data === "string" ? data : JSON.stringify(data);
  }

  return "Erro desconhecido";
}
